<img
  [src]="avatarUrl"
  [alt]="seed"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.borderRadius.%]="50" />
